export { default } from './BenefitsListCollapsedItem';
